import React from "react";
import "./ProvidersView.css";
import LeftNavigationBar from "../LeftNavigationBar/LeftNavigationBar";
import ProviderSvg from '../../assets/images/svgs/Provider.svg?react';
import maxar from '../../assets/images/brand/MAXAR.png';
import nasa from '../../assets/images/brand/NASA.png';
import sentinel from '../../assets/images/brand/sentinel-2.png';
import Planet from '../../assets/images/brand/PLANET.png';
import Antaris from '../../assets/images/brand/Antaris.png';
import Iceye from '../../assets/images/brand/ICEYE.png';
import Umbra from '../../assets/images/brand/UMBRA.png';
import Cartosat from '../../assets/images/brand/CARTOSAT.png';
import BHOONIDHI from '../../assets/images/brand/BHOONIDHI.png';
import ISRO from '../../assets/images/brand/ISRO.png';
import { useSelector } from "react-redux";


const ProviderItem = ({ name, logo, alt }) => (
    <div key={name} className="provider-item bottomBorder">
        <div className="provider-logo-container">
            <img src={logo} alt={alt} className="provider-logo" />
        </div>
        <div className="provider-name">{name}</div>
    </div>
);

const ProvidersView = () => {

    const providers = useSelector(state => state.providerDetails.providers);
    
    const getLogoByName = (name) => {
        const normalizedName = name.toLowerCase();
        if (normalizedName.includes("antaris")) return Antaris;
        if (normalizedName.includes("planet")) return Planet;
        if (normalizedName.includes("maxar")) return maxar;
        if (normalizedName.includes("bhoonidhi")) return BHOONIDHI;
        if (normalizedName.includes("sentinel")) return sentinel;
        if (normalizedName.includes("landsat")) return nasa;
        if (normalizedName.includes("iceye")) return Iceye;
        if (normalizedName.includes("umbra")) return Umbra;
        if (normalizedName.includes("cartosat")) return ISRO;
        if (normalizedName.includes("risat")) return ISRO;
        return Antaris; 
    };

    // const customProviders = [
    //     { name: "Planet", logo: Planet, alt: "Planet.io" },
    //     { name: "Maxar", logo: maxar, alt: "Maxar" },
    //     { name: "Bhoonidhi", logo: BHOONIDHI, alt: "Bhoonidhi" },
    // ];

    const allProviders = [
        ...providers.map((provider) => ({
            ...provider,
            logo: getLogoByName(provider.name),
            alt: provider.alt || provider.name, 
        })),
        // ...customProviders,
    ].sort((a, b) => a.name.localeCompare(b.name));

    return (
        <div className="providersView">
            <LeftNavigationBar />
            <div className="providers-section">
                <div className="providers-header bottomBorder">
                    <span className="providers-icon"><ProviderSvg /></span>
                    <span className="providers-title">Providers</span>
                </div>
                <div className="providers-list-view">
                    {allProviders.map((provider) => (
                        <ProviderItem
                            key={provider.name}
                            name={provider.name}
                            logo={provider.logo}
                            alt={provider.alt}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ProvidersView;
